import React from 'react';
import CombatTooltip from '../GameTip/CombatTooltip';
import { resolveEnemyStatus } from './enemyStatusMeta';
import EnemyStatusPill from './EnemyStatusPill';

/* One enemy-side status chip for the status RAIL. Reuses the exact
   `bls-status-header--tab` chassis the player status tags use (via the shared
   EnemyStatusPill), so an enemy chip and a player chip read on the same visual
   key; the per-type modifier (`bls-status-header--enemy-<type>`) adds the colored
   left stripe + icon tint, and an optional `is-<zone>` modifier tints the value
   for danger zones.

   Driven purely by the normalized backend payload row
   { key, value, max?, zone?, label? } via resolveEnemyStatus — no per-enemy
   wiring. The bare pill chrome lives in EnemyStatusPill (shared with the enemy
   tooltip's "[verb] [chip] | def" row); here it is wrapped in the same
   <CombatTooltip> as the player tags for its hover card. Renders null for an
   unresolvable/empty row so the rail can stay honest.

   This is THE enemy-side interactive chip — the exact counterpart of
   StatusTagPill's `interactive` form. `resolved` / `labelOnly` / `as` exist so the
   OUTRIGHT Engage card can embed the same chip in its "[verb] [chip] | def" rows
   without a second visual family: same chrome, same hover card, only the pill's
   text form and host element differ (GameTip/decode.jsx). `labelOnly` matches the
   embedded pill, which names the status generically because the row beside it is
   already the number's source of truth. */
function EnemyStatusChip({ status, resolved = null, labelOnly = false, as = 'div' }) {
  const r = resolved || resolveEnemyStatus(status);
  if (!r) return null;
  const Icon = r.Icon;
  return (
    <CombatTooltip
      as={as}
      color={r.color}
      name={r.label}
      placement="above-left"
      icon={Icon ? <Icon size={18} className="combat-tt__node-icon" /> : null}
      sections={[{ lines: [r.line] }]}
    >
      <EnemyStatusPill status={status} resolved={r} labelOnly={labelOnly} />
    </CombatTooltip>
  );
}

export default EnemyStatusChip;
